import React from 'react';
import {
  Button as VKWButton,
  ButtonProps as VKWButtonProps,
} from '@vw-marketing/us-components';
import { styled, useTheme } from '@vw-marketing/us-components';
import { applyCustomStylesToChildren } from '../Box/utils';

interface ButtonProps extends VKWButtonProps {
  style?: React.CSSProperties;
  className?: string;
  [key: string]: any;
}

export const StyledWrapper = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== '$customStyles',
})<{ $customStyles?: React.CSSProperties }>`
  ${({ $customStyles }) => applyCustomStylesToChildren($customStyles)}
`;

type CustomButtonProps = VKWButtonProps & { children?: React.ReactNode };
export const CustomButton = (props: CustomButtonProps) => (
  <VKWButton {...props} />
);

export const Button = React.forwardRef<HTMLDivElement, ButtonProps>(
  ({ children, style, ...rest }, ref) => {
    const theme = useTheme();
    const resolvedStyle = typeof style === 'function' ? style(theme) : style;

    return (
      <StyledWrapper ref={ref} $customStyles={resolvedStyle}>
        <CustomButton {...rest}>{children}</CustomButton>
      </StyledWrapper>
    );
  }
);

Button.displayName = 'Button';
